
/* COMPONENT IMPORTS*/

/* MODULE IMPORTS */
import React, { Component } from 'react';

/* SAME FOLDER IMPORTS*/
import DesktopSidebar from './DesktopSidebar';

/* CSS IMPORT */
import './Sidebar.css';

export class Sidebar extends Component {
    static displayName = Sidebar.name;
    constructor(props) {
        super(props);
        this.state = {
            minimized: false
        };
    }


    render() {
        const { isCollapsed, toggleSidebar } = this.props;

        let content = <DesktopSidebar isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />;
        let classes = this.props.className + " fixed-sidebar";

        return (
            <div className={classes}>
                {content}
            </div>
        );
    }
}